module.exports = __webpack_public_path__ + "static/media/video.79ca4dfb.mp4";